import { render, staticRenderFns } from "./dishes.vue?vue&type=template&id=790d749a&scoped=true&"
import script from "./dishes.vue?vue&type=script&lang=js&"
export * from "./dishes.vue?vue&type=script&lang=js&"
import style0 from "./dishes.vue?vue&type=style&index=0&id=790d749a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d749a",
  null
  
)

export default component.exports